<template>
  <v-container>
    <v-row>
      <v-col>
        <v-row class="menu mx-auto" style="max-width: 600px">
          <v-col md="4" sm="6" v-for="item in display" :key="item.guid">
            <router-link
              :to="menuTo(item)"
              @click.native="beforeGo($event, item)"
              class="menu__item pa-3"
              event
            >
              <div class="menu__item-top">
                <div v-if="item.image" class="menu__item-image mx-auto" :class="item.image"></div>
                <span v-if="item.icon" class="menu__item-logo d-block mb-3">
                  <v-icon color="grey lighten-1">mdi-{{ transformIcon(item.icon) }}</v-icon>
                </span>
                <p class="menu__item-title">{{ title(item) }}</p>
                <p class="menu__item-desc">{{ subtitle(item) }}</p>
              </div>

              <div class="menu__item-bottom">
                <span class="menu__item-more-btn grey lighten-1 ml-auto">
                  <v-icon color="white" size="20">mdi-chevron-right</v-icon>
                </span>
              </div>
            </router-link>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lang from '@/lang';

export default {
  name: 'app-home-child',
  props: {
    menu: Array,
  },
  methods: {
    menuTo(item) {
      const hasURL = !!item.url;

      return {
        name: hasURL ? 'menu.display' : 'menu.child',
        params: { id: item.guid, url: item.url },
      };
    },
    transformIcon(name) {
      return {
        kpi: 'chart-pie',
        tempo: 'axis-arrow',
        trackandtrace: 'target',
        docs: 'file-multiple',
        apps: 'console',
        shippingorder: 'map-marker-distance',
      }[name];
    },
    beforeGo(e, item) {
      e.preventDefault();

      if (item.url && item.url.startsWith('open:')) {
        window.location.href = item.url.replace('open:', '');
      } else {
        this.$router.push(this.menuTo(item));
      }
    },
    title(item) {
      return {
        en: item.titleEN,
        fr: item.titleFR,
      }[lang.locale] || item.titleEN;
    },
    subtitle(item) {
      return {
        en: item.subtitleEN,
        fr: item.subtitleFR,
      }[lang.locale] || item.subtitleEN;
    },
  },
  computed: {
    parentId() {
      return this.$route.params.id;
    },
    display() {
      return this.menu
        .filter(p => p.menu.parentId === this.parentId && p.menu.url !== ':permission')
        .map(p => p.menu)
        .sort((a, b) => (a.order > b.order ? 1 : -1));
    },
  },
};
</script>
